import { useState, useEffect } from "react";
import { updateAssetMasterDetails } from "../../Api/AssetManagement";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import Sample14 from "../../Components/Logo";
import { useAssetContext } from '../../Context/MasterContext/AssetContext';
import { useMasterDataContext } from '../../Context/masterDataContext';
import axios from "axios";
import { Base_URL } from "../../url";

export const getAssetDataById = async (asset_ID) => {
  let assetData = {
    asset_ID: asset_ID
  }
  try {
    const response = await axios.post(`${Base_URL}/AssetsList/GetAssetById`, assetData);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error showing asset details!";
  }
};

const formatDateForInput = (dateString) => {
  if (!dateString) return "";

  // If it's already in YYYY-MM-DD format, return as is
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    return dateString;
  }

  // Try to parse the date and format it
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return "";
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

const UpdateAsset = () => {
  const navigate = useNavigate();
  const { assetCatTypes, loadCatTypes, assetConTypes,
    loadConTypes, assetTypes,
    loadAssetTypes,
    deprecMethod,
    loadDeprecMethod } = useAssetContext();
  const { departmentsData, loadDepartments, merchantsData,
    loadMerchants } = useMasterDataContext();
  const [loading, setLoading] = useState(false);
  const [dropdownsLoaded, setDropdownsLoaded] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;
  const location = useLocation();
  const categoryId = location.pathname.split("/")[3];
  console.log("Category Id:", categoryId)

  const [assetData, setAssetData] = useState(null);

  const intitalValues = {
    Asset_ID: categoryId,
    asset_Category: "",
    asset_Type: "",
    brand_Model: "",
    serial_No: "",
    department: "",
    supplier_Contact_Details: "",
    warranty_Expiry: "",
    vendor_AMCID: "",
    asset_Condition: "",
    depreciation_Method: "",
    date_of_Disposal: "",
    scrap_Value: "",
    Remarks: assetData?.Remarks
  }

  const [formValues, setFormValues] = useState(intitalValues);

  const handleChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  // Load all dropdown data first
  useEffect(() => {
    const loadAllDropdowns = async () => {
      try {
        await Promise.all([
          loadCatTypes(),
          loadConTypes(),
          loadDepartments(),
          loadMerchants(),
          loadAssetTypes(),
          loadDeprecMethod()
        ]);
        setDropdownsLoaded(true);
      } catch (error) {
        toast.error(`Error loading dropdown data: ${error.message}`);
      }
    };

    loadAllDropdowns();
  }, []);

  // Once dropdowns are loaded, fetch the asset data
  useEffect(() => {
    if (dropdownsLoaded) {
      const fetchAssetDataById = async () => {
        try {
          const response = await getAssetDataById(categoryId);
          setAssetData(response);
        } catch (error) {
          toast.error(`Error loading asset data: ${error.message}`);
        }
      };

      fetchAssetDataById();
    }
  }, [categoryId, dropdownsLoaded]);

  // When both asset data and dropdowns are available, set the form values
  useEffect(() => {
    if (assetData && dropdownsLoaded) {
      console.log(assetData, 'assetData')
      setFormValues({
        Asset_ID: categoryId,
        asset_Category: assetData.asset_Category,  // asset_Category
        asset_Type: assetData.asset_Type || "",
        brand_Model: assetData.brand_Model || "",
        serial_No: assetData.serial_No || "",
        department: assetData.department,
        supplier_Contact_Details: assetData.supplier_Contact_Details || "",
        warranty_Expiry: formatDateForInput(assetData.warranty_Expiry),
        vendor_AMCID: assetData.vendor_AMCID || "",
        asset_Condition: assetData.asset_Condition || "",
        depreciation_Method: assetData.depreciation_Method || "",
        date_of_Disposal: formatDateForInput(assetData.date_of_Disposal),
        scrap_Value: assetData.scrap_Value || "",
        Remarks: assetData.remarks
      });
    }
  }, [assetData, dropdownsLoaded]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      console.log(formValues, 'formValues')
      await updateAssetMasterDetails(formValues, userId, categoryId);
      toast.success(`🦄 Updated Successfully`);
      setFormValues(intitalValues);
      navigate("/assets/view-assets");
    } catch (error) {
      toast.error(`🦄 Error : ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="main-content expand">
        <Container fluid className="fields-container">
          <h2 className="fields-title">Update Asset</h2>
          {loading && (
            <div className="loading-overlay">
              <Sample14 />
            </div>
          )}
          <Form onSubmit={handleSubmit} className="fields-form">
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Asset Category <span className="text-red">**</span></Form.Label>
                  <Form.Select
                    name="asset_Category"
                    value={formValues.asset_Category}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Category</option>
                    {assetCatTypes.map((option) => (
                      <option key={option.assetCategoryId} value={option.assetCategoryId}>
                        {option.assetCategoryDesc}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Asset Type <span className="text-red">**</span></Form.Label>
                  <Form.Select
                    name="asset_Type"
                    value={formValues.asset_Type}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Type</option>
                    {assetTypes.map((option) => (
                      <option key={option.assetTypeID} value={option.assetTypeID}>
                        {option.assetTypeDesc}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Brand <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="brand_Model"
                    value={formValues.brand_Model}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Serial Number <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="serial_No"
                    value={formValues.serial_No}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Department <span className="text-red">**</span></Form.Label>
                  <Form.Select
                    name="department"
                    value={formValues.department}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Department</option>
                    {departmentsData.map((option) => (
                      <option key={option.code} value={option.code}>
                        {option.description}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Supplier Contact Details</Form.Label>
                  <Form.Control
                    type="text"
                    name="supplier_Contact_Details"
                    value={formValues.supplier_Contact_Details}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Warranty Expiry</Form.Label>
                  <Form.Control
                    type="date"
                    name="warranty_Expiry"
                    value={formValues.warranty_Expiry}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Vendor ID</Form.Label>
                  <Form.Select
                    name="vendor_AMCID"
                    value={formValues.vendor_AMCID}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Vendor</option>
                    {merchantsData.map((option) => (
                      <option key={option.merchantCode} value={option.merchantCode}>
                        {option.merchantCode} - {option.merchantName}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Asset Condition <span className="text-red">**</span></Form.Label>
                  <Form.Select
                    name="asset_Condition"
                    value={formValues.asset_Condition}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Condition</option>
                    {assetConTypes.map((option) => (
                      <option key={option.conditionId} value={option.conditionId}>
                        {option.conditionDesc}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Depreciation Method <span className="text-red">**</span></Form.Label>
                  <Form.Select
                    name="depreciation_Method"
                    value={formValues.depreciation_Method}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Method</option>
                    {deprecMethod.map((option) => (
                      <option key={option.methodCode} value={option.methodCode}>
                        {option.methodDesc}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Date of Disposal</Form.Label>
                  <Form.Control
                    type="date"
                    name="date_of_Disposal"
                    value={formValues.date_of_Disposal}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Scrap Value</Form.Label>
                  <Form.Control
                    type="number"
                    name="scrap_Value"
                    value={formValues.scrap_Value}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Remarks</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="Remarks"
                    value={formValues.Remarks}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="fields-btn-container">
              <Button
                variant="primary"
                type="submit"
                className="fields-submit"
                disabled={loading}
              >
                {loading ? "Saving..." : "Update Asset"}
              </Button>
            </div>
          </Form>
        </Container>
      </div>
    </>
  );
};

export default UpdateAsset;